module.exports = __webpack_public_path__ + "static/assets/73077ae1577fa8af2e8544e19e447491.png";